import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IStatusPanelAngularComp } from 'ag-grid-angular';

import { SharedTranslocoModule } from '@schaeffler/transloco';

@Component({
  selector: 'cdba-total-cost-share',
  templateUrl: './total-cost-share.component.html',
  styleUrls: ['./total-cost-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedTranslocoModule],
})
export class TotalCostShareComponent implements IStatusPanelAngularComp {
  agInit(): void {
    /* required by IStatusPanelAngularComp */
  }
}
